import { useFormikContext } from 'formik';
import React from 'react';
import Select from 'react-select';
import { tCustomSelectProps } from '../Calendar.types';

export default function CustomSelect(
  props: tCustomSelectProps,
): React.ReactElement {
  const { setFieldValue } = useFormikContext();
  const { field, options, defaultOptions } = props;

  return (
    <Select
      className="w-full"
      options={options}
      onChange={(value) => setFieldValue(field.name, value)}
      defaultValue={defaultOptions}
      isMulti
    />
  );
}
